import React from 'react';
import classNames from 'classnames';
import A18n from '../../common/A18n';
import './stylesheet.scss';

const Menu = ({ activeTab }) => (
  <div className="account-menu">
    <div className="container">
      <div className="items">
        <div className={classNames({ item: true, active: activeTab === 1 })}>
          <a href="/account/show">
            <A18n rsx="customer.top_menu.m4" />
          </a>
        </div>
        <div className={classNames({ item: true, active: activeTab === 4 })}>
          <a href="/account/bills">
            <A18n rsx="customer._top_menu_level_1.m2" />
          </a>
        </div>
        <div className={classNames({ item: true, active: activeTab === 2 })}>
          <a href="/account/situation">
            <A18n rsx="customer.top_menu.m1" />
          </a>
        </div>
        <div className={classNames({ item: true, active: activeTab === 5 })}>
          <a href="/account/confirm">
            <A18n rsx="customer.top_menu.m3" />
          </a>
        </div>
        {/* <div className={classNames({ item: true, active: activeTab === 3 })} ng-if="$ctrl.userContext.subscription && $ctrl.userContext.subscription.usersCount.global > 1"> */}
        {/*  <a href="/account/multiusers"> */}
        {/*    <A18n rsx="artprice.client.default.m2" /> */}
        {/*  </a> */}
        {/* </div> */}
      </div>
    </div>
  </div>
);
export default Menu;
